// @ts-nocheck

import * as R from 'ramda';
import { AGENCY_ACCEPT_ERROR_CODES } from '../../main/screens/AccountSettings/ScreenAgencies/agenciesText';
import {
  ACCEPT_INVITE,
  FETCH_AGENCY_PERMISSIONS,
  FETCH_AGENCY_USERS,
  FETCH_AGENCY_USER_PERMISSIONS,
  FETCH_ALL_AGENCIES,
  FETCH_COUNTRIES,
  FETCH_RELATED_AGENCIES,
  INVITE_AGENCY,
  RESEND_AGENCY_INVITE,
  UPDATE_AGENCY_ORG,
} from '../actions/AgencyRelationshipActions';
import { UPDATE_TEAM_MEMBER } from '../actions/TeamActions';
import { LOADING_STATUS } from '../support/constants';
import { reducerWrapper } from '../support/utils';
import type { AgencyRelationshipReducer } from '../types/agencyRelationshipTypes';
export const INIT_STATE: AgencyRelationshipReducer = {
  acceptedAgencies: [],
  agencyPermissions: {},
  agencyPermissionsLoading: LOADING_STATUS.INIT,
  agencyUserPermissions: {},
  agencyUserPermissionsLoading: LOADING_STATUS.INIT,
  agencyUsers: {},
  agencyUsersLoading: LOADING_STATUS.INIT,
  countries: [],
  error: null,
  invitedAgencies: [],
  loadingStatus: LOADING_STATUS.INIT,
  allAgenciesLoading: LOADING_STATUS.INIT,
  uninvitedAgencies: [],
  acceptedInviteLoading: LOADING_STATUS.INIT,
  acceptedInviteError: false,
};

function Handler(state: AgencyRelationshipReducer, action) {
  const { data } = action;

  switch (action.type) {
    case INVITE_AGENCY.response:
      return Object.assign({}, state, {
        loadingStatus: LOADING_STATUS.LOADED,
        invitedAgencies: data.filter((a) => !a.accepted_invite),
        acceptedAgencies: data.filter((a) => a.accepted_invite),
      });

    case RESEND_AGENCY_INVITE.response:
      return Object.assign({}, state, {
        loadingStatus: LOADING_STATUS.LOADED,
      });

    case FETCH_RELATED_AGENCIES.response:
      return Object.assign({}, state, {
        loadingStatus: LOADING_STATUS.LOADED,
        invitedAgencies: data.filter((a) => !a.accepted_invite),
        acceptedAgencies: data.filter((a) => a.accepted_invite),
      });

    case FETCH_ALL_AGENCIES.response:
      return Object.assign({}, state, {
        allAgenciesLoading: LOADING_STATUS.LOADED,
        uninvitedAgencies: data.filter(
          (a) =>
            !R.contains(
              a.id,
              state.invitedAgencies.map((o) => o && o.organization_id)
            ) &&
            !R.contains(
              a.id,
              state.acceptedAgencies.map((o) => o && o.organization_id)
            )
        ),
      });

    case FETCH_ALL_AGENCIES.request:
      return Object.assign({}, state, {
        allAgenciesLoading: LOADING_STATUS.LOADING,
      });

    case FETCH_ALL_AGENCIES.error:
      return Object.assign({}, state, {
        allAgenciesLoading: LOADING_STATUS.ERROR,
      });

    case FETCH_AGENCY_USERS.request:
      return Object.assign({}, state, {
        agencyUsersLoading: LOADING_STATUS.LOADING,
      });

    case FETCH_AGENCY_USERS.error:
      return Object.assign({}, state, {
        agencyUsersLoading: LOADING_STATUS.ERROR,
      });

    case FETCH_AGENCY_USERS.response:
      return Object.assign({}, state, {
        agencyUsersLoading: LOADING_STATUS.LOADED,
        agencyUsers: Object.assign({}, state.agencyUsers, {
          [data.agencyId]: data.agencyUsers,
        }),
      });

    case FETCH_AGENCY_PERMISSIONS.error:
      return Object.assign({}, state, {
        agencyPermissionsLoading: LOADING_STATUS.ERROR,
      });

    case FETCH_AGENCY_PERMISSIONS.response:
      return Object.assign({}, state, {
        agencyPermissions: { ...state.agencyPermissions, [data.agencyId]: data.permissions },
        agencyPermissionsLoading: LOADING_STATUS.LOADED,
      });

    case FETCH_AGENCY_USER_PERMISSIONS.error:
      return Object.assign({}, state, {
        agencyUserPermissionsLoading: LOADING_STATUS.ERROR,
        loadingStatus: LOADING_STATUS.ERROR,
      });

    case FETCH_AGENCY_USER_PERMISSIONS.response:
      return Object.assign({}, state, {
        agencyUserPermissions: { ...state.agencyUserPermissions, [data.userId]: data.permissions },
        loadingStatus: LOADING_STATUS.LOADED,
        agencyUserPermissionsLoading: LOADING_STATUS.LOADED,
      });

    case UPDATE_AGENCY_ORG.response:
      // TODO: normalize api response so we don't have to determine what field to look at
      // https://branch.atlassian.net/browse/JOUR-3017
      const orgKey = Object.keys(data).includes('to_organization') ? 'to_organization' : 'organization_id';
      return Object.assign({}, state, {
        agencyPermissions: { ...state.agencyPermissions, [data[orgKey]]: null },
      });

    case UPDATE_TEAM_MEMBER.response:
      return Object.assign({}, state, {
        agencyUserPermissions: {},
      });

    case FETCH_COUNTRIES.response:
      const countries = Object.values(data);
      return Object.assign({}, state, {
        countries: countries,
      });

    case ACCEPT_INVITE.request:
      return Object.assign({}, state, {
        acceptedInviteError: false,
        acceptedInviteLoading: LOADING_STATUS.LOADING,
      });

    case ACCEPT_INVITE.response:
      return Object.assign({}, state, {
        acceptedInviteError: false,
        acceptedInviteLoading: LOADING_STATUS.LOADED,
      });

    case ACCEPT_INVITE.error:
      const errorCode = AGENCY_ACCEPT_ERROR_CODES[action.error.status] || AGENCY_ACCEPT_ERROR_CODES[500];
      return Object.assign({}, state, {
        acceptedInviteError: errorCode,
        acceptedInviteLoading: LOADING_STATUS.ERROR,
      });

    default:
      return state;
  }
}

export default reducerWrapper(INIT_STATE, Handler, {
  request: [INVITE_AGENCY, FETCH_RELATED_AGENCIES, RESEND_AGENCY_INVITE],
  error: [INVITE_AGENCY, FETCH_RELATED_AGENCIES, RESEND_AGENCY_INVITE],
});
